import React, { useEffect, useMemo } from "react";
import { useStripe, useElements, CardNumberElement, CardCvcElement, CardExpiryElement } from "@stripe/react-stripe-js";
import ClipLoader from "react-spinners/ClipLoader";
import axios from 'axios';
import { URL } from '../config/api';

const useOptions = () => {
  const fontSize = 16;
  const options = useMemo(
    () => ({
      showIcon: true,
      style: {
        base: {
          fontSize,
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: 'Source Code Pro, monospace',
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#9e2146"
        }
      }
    }),
    [fontSize]
  );

  return options;
};

const SplitFormEbook = (props) => {
  const stripe = useStripe();

  const elements = useElements();
  const options = useOptions();

  useEffect(() => {
    localStorage.setItem("PAYMENT_EMAIL", props.email);
  }, [props.email]);

  const handleConfirmOrder = async () => {
    if (!stripe || !elements) {
      return;
    }

    props.showLoading(true);

    if (props.email == "") {
      props.showLoading(false);
      alert("Please input email.");
      return;
    }

    const formData = new FormData();
    formData.append('Email', props.email);

    const res = await axios.post(`${URL}/stripe/create_payment_intent_ebook.php`, formData);
    if (res.data.Success) {
      const paymentIntentId = res.data.PaymentIntentId;
      const customerId = res.data.CustomerId;

      const payload = await stripe.confirmCardPayment(res.data.ClientSecret, {
        setup_future_usage: 'off_session',
        payment_method: {
          card: elements.getElement(CardNumberElement)
        }
      });

      if (payload.error) {
        props.showLoading(false);
        alert(payload.error.message);
      } else {
        registerEbookUser(paymentIntentId, customerId);
      }
    } else {
      alert(res.data.Message);
      props.showLoading(false);
    }
  }

  const registerEbookUser = async (paymentIntentId, customerId) => {
    const email = localStorage.getItem("PAYMENT_EMAIL");

    const formData = new FormData();
    formData.append('CustomerId', customerId);
    formData.append('PaymentIntentId', paymentIntentId);
    formData.append('Email', email);

    const res = await axios.post(`${URL}/stripe/register_ebook_user.php`, formData);
    if(res.data.Success) {
      alert("Purchase Successful");
      props.showLoading(false);
      window.open(
				`${URL}/stripe/download_ebook.php`,
				'_blank'
			);

      window.location.href = "/ebook-purchased";
    } else {
      props.showLoading(false);
      alert(res.data.Message);
    }
  }

  return (
    <div>
      <div>
        <div className="Text-big" style={{ marginTop: "36px" }}>
          Payment Information
        </div>

        <form className="form-back">
          <div>
            <label className="stripe-form-label font-primary-regular">
              Card number
              <CardNumberElement
                options={options}
                onReady={() => {
                }}
                onChange={event => {
                }}
                onBlur={() => {
                }}
                onFocus={() => {
                }}
              />
            </label>
          </div>

          <div>
            <label className="stripe-form-label font-primary-regular">
              Expiration date
              <CardExpiryElement
                options={options}
                onReady={() => {
                }}
                onChange={event => {
                }}
                onBlur={() => {
                }}
                onFocus={() => {
                }}
              />
            </label>
          </div>

          <div>
            <label className="stripe-form-label font-primary-regular">
              CVC
              <CardCvcElement
                options={options}
                onReady={() => {
                }}
                onChange={event => {
                }}
                onBlur={() => {
                }}
                onFocus={() => {
                }}
              />
            </label>
          </div>
        </form>

        <div className="center-horizontal" style={{ marginTop: "48px" }}>
          <div>
            <ClipLoader color="#25a66a" loading={props.loading} size={24} />
          </div>
          <div>

            <a hidden={props.loading} className="tp-caption btn btn-primary btn-primary-override font-weight-semibold" style={{ color: "#fff", padding: "14px 70px", fontSize: 16 }} onClick={handleConfirmOrder}>{props.paymentType == 1 ? "Start Free Trial" : "Purchase Now"}</a>
            <div className="term-view" style={{ marginTop: "1rem" }}>
              {props.paymentType == 1 ? "By starting your free trial you agree to the" : "By purchasing you agree to the"} <a target="_blank" className="term" href="term">terms of service</a>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export default SplitFormEbook;